import { Children } from 'react';
import cn from 'classnames';
import MenuDispatcher from './MenuDispatcher.jsx';

export default function ExoMenu({
  menuAriaLabel = 'Global',
  isMobile = false,
  menuItems = [],
  children,
  customItemPosition = 'after',
  customItemMobilePadding = '0px',
  closeMegaMenuLabel = 'Close Mega Menu',
  className = '',
  ...rest
}) {
  if (menuItems.length <= 0 && !children) return null;

  // Render custom menu items as chidlren
  function renderCustomMenuItem(children, customItemPosition, position) {
    if (children && customItemPosition === position) {
      const paddingValue = customItemMobilePadding || '0px';
      const mobilePadding = isMobile ? paddingValue : '0px';
      return Children.map(children, (child, index) => (
        <li className="lds-header-menu-item " key={`customComponent-${index}`}>
          <div className="lds-header-menu-item-content custom-item">
            <div style={{ padding: mobilePadding }}>{child}</div>
          </div>
        </li>
      ));
    }
    return null;
  }

  return (
    <nav
      aria-label={menuAriaLabel}
      className={cn(
        'lds-header-exo',
        `${isMobile ? 'lds-header-exo-mobile' : 'wrapper'}`,
        className
      )}
      {...rest}
    >
      <ul className="lds-header-menu lds-header-menu-exo lds-header-menu-right">
        {renderCustomMenuItem(
          children,
          customItemPosition,
          'before'
        )}
        {menuItems.length > 0 && menuItems.map((item, index) => (
          <MenuDispatcher
            key={index}
            index={index}
            menuType="exo"
            {...item}
            isMobile={isMobile}
            closeMegaMenuLabel={closeMegaMenuLabel}
          />
        ))}
        {renderCustomMenuItem(
          children,
          customItemPosition,
          'after'
        )}
      </ul>
    </nav>
  );
}
